import { API } from 'aws-amplify';
import {
  REACT_APP_BASE_KEY,
  REACT_APP_BASE_NAME,
  REACT_APP_CLIENT_NAME,
} from '../config/settings/environments';

/**
 * To get the real time report.
 */
export const getRealTime = async () => {
  const paths = {
    talabre: '/v1/daily-real-time',
  };
  let path = paths[REACT_APP_CLIENT_NAME] || '/v1/daily-real-time';

  const response = await API.get(REACT_APP_BASE_NAME, path, {
    headers: { 'x-api-key': REACT_APP_BASE_KEY },
    response: true,
  });

  return {
    data: response.data,
    headers: response.headers,
    request: response.config,
    status: response.status,
  };
};

/**
 * To get the real time report.
 */
export const getRealTimeReports = async type => {
  const paths = {
    talabre: '/v1/real-time',
  };
  let path = paths[REACT_APP_CLIENT_NAME] || '/v1/real-time';
  path = `${path}?report_type=${type}`;
  const response = await API.get(REACT_APP_BASE_NAME, path, {
    headers: { 'x-api-key': REACT_APP_BASE_KEY },
    response: true,
  });

  return {
    data: response.data,
    headers: response.headers,
    request: response.config,
    status: response.status,
  };
};

/**
 * To get the Anomalies Cycle.
 */
export const readAnomaliesCycle = async ({ year, month, day, shift }) => {
  const paths = {
    talabre: '/v1/get-anomalies-cycles',
  };
  let path = paths[REACT_APP_CLIENT_NAME] || '/v1/get-anomalies-cycles';
  if (year && month && day) {
    path = `${path}?year=${year}&month=${month}&day=${day}&shift=${shift}`;
  }
  const response = await API.get(REACT_APP_BASE_NAME, path, {
    headers: { 'x-api-key': REACT_APP_BASE_KEY },
    response: true,
  });

  return {
    data: response.data,
    headers: response.headers,
    request: response.config,
    status: response.status,
  };
};

/**
 * To get the Anomalies Cycle.
 */
export const readTruckGpsPoints = async ({
  patente,
  fecha_inicio,
  fecha_termino,
}) => {
  const paths = {
    talabre: '/v1/get-anomalies-cycles-gps',
  };
  let path = paths[REACT_APP_CLIENT_NAME] || '/v1/get-anomalies-cycles-gps';

  if (patente && fecha_inicio && fecha_termino) {
    // URL encode the datetime strings to handle spaces and special characters
    const encodedInicio = encodeURIComponent(fecha_inicio);
    const encodedTermino = encodeURIComponent(fecha_termino);
    path = `${path}?patente=${patente}&fecha_inicio=${encodedInicio}&fecha_termino=${encodedTermino}`;
  }

  const response = await API.get(REACT_APP_BASE_NAME, path, {
    headers: { 'x-api-key': REACT_APP_BASE_KEY },
    response: true,
  });

  return {
    data: response.data,
    headers: response.headers,
    request: response.config,
    status: response.status,
  };
};

/**
 * To get production targets
 */
export const getProductionTargets = async () => {
  const paths = {
    talabre: '/v1/get-put-targets',
  };
  let path = paths[REACT_APP_CLIENT_NAME] || '/v1/get-put-targets';

  const response = await API.get(REACT_APP_BASE_NAME, path, {
    headers: { 'x-api-key': REACT_APP_BASE_KEY },
    response: true,
  });

  return {
    data: response.data,
    headers: response.headers,
    request: response.config,
    status: response.status,
  };
};

/**
 * To save production targets
 */
export const saveProductionTargets = async targets => {
  const paths = {
    talabre: '/v1/get-put-targets',
  };
  let path = paths[REACT_APP_CLIENT_NAME] || '/v1/get-put-targets';

  const response = await API.post(REACT_APP_BASE_NAME, path, {
    headers: { 'x-api-key': REACT_APP_BASE_KEY },
    body: { targets },
    response: true,
  });

  return {
    data: response.data,
    headers: response.headers,
    request: response.config,
    status: response.status,
  };
};

/**
 * To get fuel events for a specific tanker truck.
 * @param {string} patent - e.g. 'SZBX30'
 */
export const getFuel = async patent => {
  const paths = { talabre: '/v1/get-put-fuel' };
  let path = paths[REACT_APP_CLIENT_NAME] || '/v1/get-put-fuel';
  path = `${path}?patent=${patent}`;

  const response = await API.get(REACT_APP_BASE_NAME, path, {
    headers: { 'x-api-key': REACT_APP_BASE_KEY },
    response: true,
  });
  return {
    data: response.data,
    headers: response.headers,
    request: response.config,
    status: response.status,
  };
};

/**
 * To add fuel to a specific tanker truck.
 * params: { volumen_total, patent, device_id }
 */
export const addFuel = async params => {
  const paths = { talabre: '/v1/get-put-fuel' };
  const path = paths[REACT_APP_CLIENT_NAME] || '/v1/get-put-fuel';

  const response = await API.post(REACT_APP_BASE_NAME, path, {
    headers: { 'x-api-key': REACT_APP_BASE_KEY },
    response: true,
    body: params,
  });
  return {
    data: response.data,
    headers: response.headers,
    request: response.config,
    status: response.status,
  };
};
